import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const RefreshIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="m8.518.44 3.042 3.149L8.48 6.56 7.44 5.481l1.202-1.16h-.638C5.206 4.334 2.92 6.608 2.92 9.4a5.08 5.08 0 0 0 10.16 0v-.75h1.5v.75a6.58 6.58 0 1 1-13.16 0c0-3.628 2.964-6.561 6.576-6.58h.737L7.439 1.48 8.52.44Z" />
  </IconWrapper>
)

export default RefreshIconSmall
